import React from 'react';
import {
  Sparkles,
  Thermometer,
  Wrench,
  Car,
  Bone,
  Scale,
  Dumbbell,
  Flower2,
  UtensilsCrossed,
  Truck,
  Clapperboard,
  Plus,
  LucideIcon,
} from 'lucide-react';

/** Real, named icons per vertical - no hand-drawn glyphs. */
const ICONS: Record<string, LucideIcon> = {
  medspa: Sparkles,
  hvac: Thermometer,
  plumbing: Wrench,
  auto: Car,
  ortho: Bone,
  law: Scale,
  gym: Dumbbell,
  pilates: Flower2,
  restaurant: UtensilsCrossed,
  trucking: Truck,
  creators: Clapperboard,
  more: Plus,
};

const IndustryIcon: React.FC<{ name: string }> = ({ name }) => {
  const Icon = ICONS[name] ?? Plus;
  return <Icon className="ind__icon" width={22} height={22} strokeWidth={1.75} aria-hidden="true" />;
};

export default React.memo(IndustryIcon);
